(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["utc-lead-assistant"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('utc-lead-assistant')) {
    customElements.define('utc-lead-assistant', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.steps = [...this.querySelectorAll('[data-step]')];
        this.launcher = this.querySelector('.utc-lead-launcher');
        this.error = this.querySelector('.utc-lead-error');
        this.copy = JSON.parse(this.querySelector('.utc-lead-copy').textContent);
        this.index = 0;
        this.busy = false;
        this.complete = false;
        this.submissionId = crypto.randomUUID();
        this.storageKey = 'utc-lead-assistant-v1';
        this.elapsed = 0;
        try { this.session = JSON.parse(sessionStorage.getItem(this.storageKey) || '{}'); } catch { this.session = {}; }
        this.elapsed = Math.max(0, Number(this.session.elapsed) || 0);
        this.launcher.addEventListener('click', () => this.open());
        this.querySelector('.utc-lead-close').addEventListener('click', () => this.close());
        this.querySelector('.utc-lead-done').addEventListener('click', () => this.close());
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); });
        this.dialog.addEventListener('close', () => { this.remember({ dismissed: true }); this.launcher.hidden = false; this.launcher.setAttribute('aria-expanded','false'); if (this.returnFocus) this.launcher.focus({ preventScroll: true }); });
        this.onEscape = event => { if (event.key === 'Escape' && this.dialog.open && !document.querySelector('dialog[open]:not(.utc-lead-dialog)')) { if (this.dialog.contains(document.activeElement)) event.preventDefault(); this.close(); } };
        document.addEventListener('keydown',this.onEscape);
        this.querySelector('.utc-lead-back').addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('.utc-lead-next').addEventListener('click', () => { if (this.valid(this.index)) this.show(this.index + 1); });
        this.form.addEventListener('submit', event => { event.preventDefault(); if (this.index < 4) { if (this.valid(this.index)) this.show(this.index + 1); } else this.submit(); });
        this.form.addEventListener('input', event => { event.target.setCustomValidity?.(''); this.error.hidden = true; });
        const zone = this.form.elements.timeZone;
        zone.value = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
        try { Intl.supportedValuesOf('timeZone').forEach(value => { const option = document.createElement('option'); option.value = value; this.querySelector('datalist').append(option); }); } catch {}
        this.show(0, false);
        this.lastTick = performance.now();
        this.tick = () => {
          const now = performance.now();
          if (!document.hidden && !this.session.dismissed && !this.session.opened) this.elapsed += Math.min(now - this.lastTick, 1500);
          this.lastTick = now;
          if (this.session.dismissed || this.session.opened) { clearInterval(this.timer); return; }
          this.remember({ elapsed: this.elapsed });
          if (this.elapsed >= Number(this.dataset.delayMs || 15000) && !document.hidden && !document.querySelector('dialog[open]') && !document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) this.open(false);
        };
        if (!this.session.dismissed && !this.session.opened) this.timer = setInterval(this.tick, 250);
        this.onVisibility = () => { this.lastTick = performance.now(); };
        document.addEventListener('visibilitychange', this.onVisibility);
      }
      disconnectedCallback() { clearInterval(this.timer); document.removeEventListener('visibilitychange', this.onVisibility); document.removeEventListener('keydown',this.onEscape); }
      remember(values) { Object.assign(this.session, values); try { sessionStorage.setItem(this.storageKey, JSON.stringify(this.session)); } catch {} }
      open(manual = true) { if (this.dialog.open) return; this.remember({ opened: true }); clearInterval(this.timer); const previous = document.activeElement; this.dialog.show(); this.launcher.hidden = true; this.launcher.setAttribute('aria-expanded','true'); this.show(this.index,manual); if (!manual && previous) { const hadTabindex = previous.hasAttribute('tabindex'); if (previous === document.body) previous.setAttribute('tabindex','-1'); previous.focus({preventScroll:true}); if (!hadTabindex && previous === document.body) previous.removeAttribute('tabindex'); } }
      close() { this.returnFocus = this.dialog.contains(document.activeElement); this.remember({ dismissed: true }); clearInterval(this.timer); this.dialog.close(); }
      show(index, focus = true) {
        this.index = Math.max(0, Math.min(4, index));
        this.steps.forEach((step, number) => { step.hidden = number !== this.index; });
        this.querySelector('.utc-lead-back').hidden = this.index === 0;
        this.querySelector('.utc-lead-next').hidden = this.index === 4;
        this.querySelector('.utc-lead-submit').hidden = this.index !== 4;
        this.querySelector('.utc-lead-progress').textContent = `${this.copy.step} ${this.index + 1} ${this.copy.of} 5`;
        this.querySelector('.utc-lead-progress-track span').style.width = `${(this.index + 1) * 20}%`;
        this.error.hidden = true;
        if (this.index === 4) this.review();
        if (focus && !this.complete) this.steps[this.index].querySelector('legend').focus({ preventScroll: true });
        if (this.complete && focus) this.querySelector('.utc-lead-success').focus({ preventScroll: true });
      }
      valid(index) {
        const elements = [...this.steps[index].querySelectorAll('input,select,textarea')];
        if (index === 2) { const phone = this.form.elements.phone; phone.setCustomValidity(phone.value.replace(/\D/g,'').length < 7 ? this.copy.phoneError : ''); const name = this.form.elements.name; name.setCustomValidity(name.value.trim() ? '' : this.copy.validationError); }
        if (index === 3) {
          const zone = this.form.elements.timeZone; zone.setCustomValidity('');
          try { new Intl.DateTimeFormat('en-US',{timeZone:zone.value}); } catch { zone.setCustomValidity(this.copy.timezoneError); }
          const date = this.form.elements.date; date.setCustomValidity('');
          const time = this.form.elements.time; time.setCustomValidity('');
          if (Boolean(date.value) !== Boolean(time.value)) (date.value ? time : date).setCustomValidity(this.copy.schedulePairError);
          if (date.value && zone.checkValidity()) { const parts = new Intl.DateTimeFormat('en-CA',{timeZone:zone.value,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()); const values = Object.fromEntries(parts.map(part => [part.type,part.value])); if (date.value < `${values.year}-${values.month}-${values.day}`) date.setCustomValidity(this.copy.dateError); }
        }
        const invalid = elements.find(element => !element.checkValidity());
        if (invalid) { this.error.textContent = this.copy.validationError; this.error.hidden = false; invalid.focus(); invalid.reportValidity(); return false; }
        return true;
      }
      values() { return Object.fromEntries(new FormData(this.form)); }
      review() {
        const values = this.values();
        const list = this.querySelector('.utc-lead-review'); list.replaceChildren();
        const service = this.querySelector(`input[name="service"][value="${values.service}"]`);
        const industry = this.form.elements.industry.selectedOptions[0];
        const rows = [['service', service?.nextElementSibling?.textContent],['industry', industry?.textContent],['organization', values.organization],['name', values.name],['email', values.email],['phone', values.phone],['date', values.date],['time', values.time],['timeZone', values.timeZone],['message', values.message]];
        for (const [key, value] of rows) { const dt = document.createElement('dt'); dt.textContent = this.copy[key]; const dd = document.createElement('dd'); dd.textContent = value || this.copy.notSpecified; list.append(dt,dd); }
      }
      async submit() {
        if (this.busy || this.complete) return;
        for (let index=0;index<5;index++) { if (!this.valid(index)) { this.show(index); this.valid(index); return; } }
        const values = this.values();
        let context = {}; try { context = window.UTCVisitorContext?.getIDs() || {}; } catch {}
        const analyticsConsent = Boolean(context.visitor_id && context.session_id);
        const serviceLabel = this.querySelector(`input[name="service"][value="${values.service}"]`).nextElementSibling.textContent.trim();
        const payload = { action:'lead', submission_id:this.submissionId, visitor_id:analyticsConsent ? context.visitor_id : null, session_id:analyticsConsent ? context.session_id : null, analytics_consent:analyticsConsent, services:[serviceLabel], industry:this.form.elements.industry.selectedOptions[0].textContent.trim(), organization:values.organization.trim(), name:values.name.trim(), phone:values.phone.trim(), email:values.email.trim(), message:values.message.trim(), consultation_day:values.date || null, consultation_time:values.time || null, timezone:values.timeZone, contact_consent:true, consent_version:'utc-contact-v1', website:values.website || '' };
        this.busy = true;
        const button = this.querySelector('.utc-lead-submit'); button.disabled = true; button.textContent = this.copy.sending;
        this.querySelector('.utc-lead-back').disabled = true;
        this.form.setAttribute('aria-busy','true');
        const abort = new AbortController(); const timeout = setTimeout(() => abort.abort(),20000);
        try {
          const endpoint = new URL(this.dataset.endpoint);
          if (endpoint.protocol !== 'https:' && endpoint.hostname !== 'localhost' && endpoint.hostname !== '127.0.0.1') throw new Error('Invalid endpoint');
          const headers = {'Content-Type':'application/json'};
          if (this.dataset.publicKey) headers.apikey = this.dataset.publicKey;
          if (this.dataset.authorization) headers.Authorization = `Bearer ${this.dataset.authorization}`;
          const response = await fetch(endpoint.href,{method:'POST',headers,body:JSON.stringify(payload),signal:abort.signal,credentials:'omit',referrerPolicy:'no-referrer'});
          const result = await response.json();
          if (!response.ok || result.accepted !== true || result.submission_id !== this.submissionId) throw new Error('Submission failed');
          this.complete = true; this.remember({ submitted:true,dismissed:true }); this.form.hidden = true; this.querySelector('.utc-lead-success').hidden = false;
          this.querySelector('.utc-lead-progress').hidden = true; this.querySelector('.utc-lead-progress-track').hidden = true; this.querySelector('.utc-lead-success').focus({preventScroll:true});
        } catch { this.error.textContent = this.copy.sendError; this.error.hidden = false; }
        finally { clearTimeout(timeout); this.busy = false; button.disabled = false; button.textContent = this.copy.submit; this.querySelector('.utc-lead-back').disabled = false; this.form.removeAttribute('aria-busy'); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["utc-visitor-activity"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const config = document.querySelector('[data-utc-analytics]');
  if (!config || window.UTCVisitorContext || window.Shopify?.designMode || window.Shopify?.previewMode || /\/(account|checkout|checkouts|orders|search|pages\/utc-admin)(\/|$)/.test(location.pathname)) return;
  const endpoint = config.dataset.endpoint;
  const publicKey = config.dataset.publicKey;
  if (!endpoint || !publicKey) return;
  const VISITOR_KEY = 'utc:visitor:v1';
  const SESSION_KEY = 'utc:visit:v1';
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const idleLimit = 30000, sessionLimit = 1800000, visitorLimit = 7776000000;
  let allowed = false, visitor = null, session = null, pageId = null;
  let lastTick = Date.now(), lastActivity = Date.now(), activeMs = 0;
  let queue = [], sending = false, path = cleanPath(location.pathname), attempts = 0;
  function cleanPath(raw) {
    const s = String(raw || '/').split(/[?#]/)[0];
    if (s === '/' || s === '/cart') return s;
    if (s.length <= 256 && /^\/(products|collections|pages|policies)\/[a-z0-9-]+\/?$/i.test(s) && !s.startsWith('/pages/utc-admin')) return s;
    return '/other';
  }
  function read(storage, key) { try { return JSON.parse(storage.getItem(key)); } catch { return null; } }
  function write(storage, key, value) { try { storage.setItem(key, JSON.stringify(value)); } catch {} }
  function remove(storage, key) { try { storage.removeItem(key); } catch {} }
  function privacyAllowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch { return false; }
  }
  function identifiers() {
    if (!allowed || !privacyAllowed()) return { visitor_id: null, session_id: null };
    rotateIfIdle();
    return { visitor_id: visitor?.id || null, session_id: session?.id || null };
  }
  window.UTCVisitorContext = Object.freeze({ getIDs: identifiers });
  function enqueue(type, extra = {}) {
    if (!allowed || !visitor || !session) return;
    queue.push({ id: crypto.randomUUID(), type, page_view_id: pageId, path, occurred_at: new Date().toISOString(), ...extra });
    if (queue.length > 100) queue.shift();
  }
  function beginPage() {
    path = cleanPath(location.pathname); pageId = crypto.randomUUID();
    lastTick = Date.now(); activeMs = 0; enqueue('page_view');
  }
  function beginSession() {
    const now = Date.now();
    const previous = read(sessionStorage, SESSION_KEY);
    session = previous && UUID.test(previous.id) && now - previous.last < sessionLimit ? previous : { id: crypto.randomUUID(), last: now };
    write(sessionStorage, SESSION_KEY, session); beginPage();
  }
  function rotateIfIdle() {
    if (allowed && session && Date.now() - session.last >= sessionLimit) {
      void flush(); queue = []; session = { id: crypto.randomUUID(), last: Date.now() };
      write(sessionStorage, SESSION_KEY, session); beginPage();
    }
  }
  function consentChanged() {
    const next = privacyAllowed();
    if (next === allowed) return;
    allowed = next;
    if (!allowed) {
      queue = []; activeMs = 0; visitor = session = pageId = null;
      remove(localStorage, VISITOR_KEY); remove(sessionStorage, SESSION_KEY); return;
    }
    const old = read(localStorage, VISITOR_KEY), now = Date.now();
    visitor = old && UUID.test(old.id) && now - old.last < visitorLimit ? old : { id: crypto.randomUUID(), last: now };
    visitor.last = now; write(localStorage, VISITOR_KEY, visitor);
    lastActivity = now; beginSession(); void flush();
  }
  function tick() {
    const now = Date.now();
    if (allowed && !document.hidden && document.hasFocus()) activeMs += Math.max(0, Math.min(now - lastTick, idleLimit - (lastTick - lastActivity), 5000));
    lastTick = now;
  }
  function engagement() {
    tick();
    if (activeMs > 0) { enqueue('engagement', { active_ms: Math.min(30000, Math.round(activeMs)) }); activeMs = 0; }
  }
  async function flush() {
    if (!allowed || !privacyAllowed() || sending || !queue.length || !session) return;
    sending = true;
    const batch = queue.splice(0, 30), ids = { visitor_id: visitor.id, session_id: session.id };
    try {
      const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', apikey: publicKey, Authorization: `Bearer ${publicKey}` }, body: JSON.stringify({ action: 'events', ...ids, consent: true, events: batch }), keepalive: true, credentials: 'omit' });
      if (!response.ok) throw new Error('event delivery');
    } catch {
      if (allowed && session?.id === ids.session_id) queue = [...batch, ...queue].slice(-100);
    } finally { sending = false; }
  }
  function activity() {
    if (!allowed) return;
    tick(); rotateIfIdle(); lastActivity = Date.now();
    session.last = lastActivity; write(sessionStorage, SESSION_KEY, session);
  }
  ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(event => document.addEventListener(event, activity, { passive: true }));
  document.addEventListener('click', event => {
    if (!allowed) return;
    const node = event.target instanceof Element ? event.target : null;
    if (!node || node.closest('form, [data-utc-lead-assistant], [data-utc-assistant], [data-utc-admin], #utc-lead-assistant, #utc-admin')) return;
    let target = 'page';
    const link = node.closest('a[href]');
    if (link) {
      try { const url = new URL(link.href, location.origin); target = url.origin === location.origin ? `link:${cleanPath(url.pathname)}` : 'external-link'; } catch { target = 'link'; }
    } else if (node.closest('button,[role="button"]')) target = 'button';
    else if (node.closest('input,select,textarea')) target = 'control';
    enqueue('click', { target: target.slice(0, 100) });
  }, { passive: true });
  document.addEventListener('visibilitychange', () => { engagement(); lastTick = Date.now(); if (!document.hidden) activity(); void flush(); });
  window.addEventListener('pagehide', () => { engagement(); void flush(); });
  window.addEventListener('blur', () => { engagement(); void flush(); });
  window.addEventListener('focus', activity);
  window.addEventListener('pageshow', event => { if (event.persisted && allowed) { lastActivity = Date.now(); beginPage(); void flush(); } });
  window.addEventListener('online', () => void flush());
  document.addEventListener('visitorConsentCollected', consentChanged);
  setInterval(() => { if (allowed && !privacyAllowed()) consentChanged(); tick(); }, 5000);
  setInterval(() => { if (allowed) { engagement(); void flush(); } }, 15000);
  function loadPrivacy() {
    consentChanged();
    if (window.Shopify?.customerPrivacy) return;
    if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], consentChanged);
    else if (++attempts < 10) setTimeout(loadPrivacy, 1000);
  }
  loadPrivacy();
})();
  } catch(e) { console.error(e); }
})();

})();
